import { bind } from '@react-rxjs/core'
import { of, switchMap } from 'rxjs'

import { sanityDispensaryCdn$ } from '../../sanity-dispensaries/query'
import { latestDispensary$ } from '../state'

export const [useDispensaryOptedIntoGlobalPromotions, dispensaryOptedIntoGlobalPromotions$] = bind(
  latestDispensary$.pipe(
    switchMap((dispensary) =>
      dispensary
        ? sanityDispensaryCdn$.pipe(
            switchMap((result) =>
              result._tag === 'Left' || !result.data
                ? of(false)
                : of(!!result.data.optedIntoGlobalPromotions),
            ),
          )
        : of(false),
    ),
  ),
)
